import { Directive, Input, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { EditorView } from 'prosemirror-view';
import { Editor } from 'ngx-editor';
import { ICONS } from '@nimbus-library/features/shared/resources/icons';
import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';

@UntilDestroy()
@Directive()
export abstract class BaseRichTextMenuItemComponent implements OnInit {
  @Input() public editor: Editor;

  public readonly ICONS = ICONS;
  public readonly TranslationKeys = TranslationKeys;

  protected abstract update(view: EditorView): void;

  public ngOnInit(): void {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.editor.update.pipe(untilDestroyed(this)).subscribe((view: any) => this.update(view));
  }
}
